import React from "react";
import {t} from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";

export default function cashoutbyticket () {
    return (
        <React.Fragment>
            <div className="ticket-results-view-p">
            <CountDownComponent second={30}/>
            <div className='back-arrrow' onClick={this.props.openPopup('cashOutType')}></div>
            <div className="mini-logo-container"></div>
            <p className='cashout-p'>{t(`Would you like to cashout?`)}</p>
                <div className='cashouttype-popup'>
                    <button className="button-view" onClick={this.cashoutByTicket()}>{t("Yes")}</button>
                    <button className="button-view" onClick={this.props.closePopup()}>{t("Cancel")}</button>
                </div>
            </div>
        </React.Fragment>
    );
}